export default __webpack_public_path__ + "56a640c0ceb1a427eef9db8d2a32ebf4.png";